import { Injectable, signal, WritableSignal } from '@angular/core';
// import { IIqUser } from '@dat/iq-proxy';
import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs'
import { emptyDatadogLogsInitConfig } from '../models';

@Injectable({
  providedIn: 'root'
})
export class IqDatadogLogsService {

    isReady: WritableSignal<boolean> = signal(false);

    constructor() {}

    init(config: LogsInitConfiguration): void {
        if (!config.env || !config.clientToken) {
            console.error('Missing required Datadog Logs parameters.');
            return;
        }
        const initCongig: LogsInitConfiguration = {
            ...emptyDatadogLogsInitConfig,
            ...config
        };
        datadogLogs.init(initCongig);
    }

    setUser(user: any): void {
        const id: string = user.id ?? 'unknown';
        const name: string = user.oAuthProfile?.name ?? 'unknown';
        const email: string = user.oAuthProfile?.emailAddress ?? 'unknown';

        const csbId: number | undefined = user.oAuthProfile?.csbId;

        datadogLogs.setUser({
            id,
            name,
            email,
            csbId
        });
        this.isReady.set(true);
    }

    /**
     * This does not work currently.
     * Debug logs are disabled in datadog due to expense incurred by
     * sheer volumes. Debug logs can be re-enabled on a service on a
     * case-by-case basis, so keeping this around just in case debug
     * logs are re-enabled for iQ in the future.
     * 
     * (orr.epstein)
     */
    debug(message: string, context?: object, error?: Error): void {
        if (this.isReady()) {
            datadogLogs.logger.debug(message, context, error);
            return;
        }

        const interval = setInterval(() => {
            if (!this.isReady()) return;

            clearInterval(interval);
            datadogLogs.logger.debug(message, context, error);
        }, 50);
    }

    info(message: string, context?: object, error?: Error): void {
        if (this.isReady()) {
            datadogLogs.logger.info(message, context, error);
            return;
        }

        const interval = setInterval(() => {
            if (!this.isReady()) return;

            clearInterval(interval);
            datadogLogs.logger.info(message, context, error);
        }, 50);
    }

    warn(message: string, context?: object, error?: Error): void {
        if (this.isReady()) {
            datadogLogs.logger.warn(message, context, error);
            return;
        }
        
        const interval = setInterval(() => {
            if (!this.isReady()) return;
            
            clearInterval(interval);
            datadogLogs.logger.warn(message, context, error);
        }, 50);
    }

    error(message: string, context?: object, error?: Error): void {
        if (this.isReady()) {
            datadogLogs.logger.error(message, context, error);
            return;
        }
        
        const interval = setInterval(() => {
            if (!this.isReady()) return;
            
            clearInterval(interval);
            datadogLogs.logger.error(message, context, error);
        }, 50);
    }
}
